export const DataRate = [
  {
    key: 'Tốt',
    value: 'Tốt'
  },
  {
    key: 'Bình Thường',
    value: 'Bình Thường'
  },
  {
    key: 'Không tốt',
    value: 'Không tốt'
  },
]